import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import MainApp from './main';

import './style.css';

class App extends Component {
    render() {
        return (
            <div className="wrapper">
                <div className="box-inner">
                    <Switch>
                        <Route path="/:city" component={MainApp} />
                        <Route exact path="/" component={MainApp} />
                    </Switch>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { selectedCity, cities } = state.app;
    return { selectedCity, cities }
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js